export default __webpack_public_path__ + "static/media/misc001.a989e47d.jpeg";